import * as React from 'react'
import { PropsWithChildren } from 'react'
import { Col, Row } from '../../../ui/grid'
import { Box, BoxHeader, BoxTitle } from '../../../ui/box'
import BoxBody from '../../../helper/boxBody'
import { ServerCapability } from '../../../helper/ServerCapability'

type Props = {}

export class TracepointFormWrapper extends React.Component<PropsWithChildren<Props>> {
    public render = (): React.ReactNode => {
        return (
            <Row>
                <Col widthLarge={6} centered>
                    <Box>
                        <BoxHeader>
                            <nav className="navbar navbar-toolbar">
                                <div className="container-fluid">
                                    <BoxTitle>
                                        <i className="fa fa-crosshairs burning" />
                                        &nbsp; Configure Tracepoint to Boost Traces
                                    </BoxTitle>
                                </div>
                            </nav>
                        </BoxHeader>
                        <BoxBody noPadding>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="mb-1 tw-p-16 tw-bg-grey-50 tw-color-grey-800">
                                        By configuring a tracepoint you can temporarily boost the amount of traces from this
                                        endpoint/transaction for a short amount of time. Only traces that are collected with your
                                        configured&nbsp;
                                        <a
                                            href="https://support.tideways.com/article/43-sampling?utm_medium=app&utm_source=tracepoint-form&utm_campaign=sampling"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <i className="fa fa-question-circle tw-color-grey-600" /> sampling rate
                                        </a>{' '}
                                        will be matched by this tracepoint.
                                    </div>
                                    <ServerCapability capability="TraceBoosting" level="warning" expanded>
                                        {this.props.children}
                                    </ServerCapability>
                                </div>
                            </div>
                        </BoxBody>
                    </Box>
                </Col>
            </Row>
        )
    }
}
